export default __webpack_public_path__ + "static/media/gallery154_1.f1f8d22d.png";